import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import { API_STATUS, ApiStatusDisplayType } from '../../types';
import {
  StyledCard,
  ImageContainer,
  CardImage,
  CardTitle,
  CardDescription,
  CardBody,
  CardActions,
  ActionButton,
  StyledChip,
  CardSubtitle,
  CardTitleWrapper,
  StatusBadge,
  AccessBadgeSlot,
} from './ApiCard.styles';
import { AccessGrantedBadge, AccessLockBadge } from '../badges';

export interface ApiCardProps {
  image?: string;
  title?: string;
  productType?: string;
  description?: string;
  subtitle?: string;
  price?: string | number;
  buttonLabel?: string;
  onActionClick?: () => void;
  isNew: boolean;
  isDeprecated: boolean;
  isAccessGranted: boolean | null;
}

function getDisplayBadge(
  isNewStatus: boolean,
  isDeprecatedStatus: boolean,
): ApiStatusDisplayType {
  if (isDeprecatedStatus) return API_STATUS.DEPRECATED;
  if (isNewStatus) return API_STATUS.NEW;
  return null;
}

const ApiCard: React.FC<ApiCardProps> = ({
  image = '',
  title = '',
  productType = '',
  description = '',
  subtitle = '',
  buttonLabel = 'Get More Info',
  onActionClick,
  isNew,
  isDeprecated,
  isAccessGranted,
}) => {
  const displayBadge = getDisplayBadge(isNew, isDeprecated);
  return (
    <StyledCard>
      <ImageContainer>
        <CardImage src={image} alt={title || 'Product Preview'} />
        {displayBadge && <StatusBadge>{displayBadge}</StatusBadge>}
        {isAccessGranted && (
          <AccessBadgeSlot>
            <AccessGrantedBadge />
          </AccessBadgeSlot>
        )}
        {isAccessGranted === false && (
          <AccessBadgeSlot>
            <AccessLockBadge />
          </AccessBadgeSlot>
        )}
      </ImageContainer>

      <CardBody>
        <CardTitleWrapper>
          <CardTitle title={title} variant="h6">
            {title}
          </CardTitle>
          {subtitle && <CardSubtitle title={subtitle}>{subtitle}</CardSubtitle>}
        </CardTitleWrapper>
        {productType && (
          <div>
            <StyledChip label={productType} color="primary" size="small" />
          </div>
        )}
        {description && (
          <CardDescription title={description}>{description}</CardDescription>
        )}
      </CardBody>

      <CardActions>
        <ActionButton
          disableRipple
          endIcon={<ArrowForwardIcon />}
          variant="text"
          onClick={onActionClick}
        >
          {buttonLabel}
        </ActionButton>
      </CardActions>
    </StyledCard>
  );
};

export default ApiCard;
